import { confirmDialog } from 'primereact/confirmdialog';
import { confirmPopup } from "primereact/confirmpopup";
import React, { createContext, useContext } from "react";
import { useTranslation } from "react-i18next";
import { ToasterServiceProvider } from "./toaster.service";

let operationsAllowed: any = {};
const UIServiceContext = createContext(operationsAllowed);

export const UIServiceProvider = (props: any) => {
  const { t } = useTranslation();

  const showConfirmDeletePopup = (
    event: any,
    data: any,
    acceptFunction: Function,
    rejectFunction?: Function,
    messageKey?: string
  ) => {
    if (event && event.currentTarget) {
      confirmPopup({
        target: event.currentTarget,
        message: messageKey ? t(messageKey) : t("generic.label.confirmDelete"),
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        accept: () => acceptFunction(data),
        reject: () => rejectFunction ? rejectFunction() : undefined,
      });
    }
  };

  const showConfirmDeleteDialog = (
    data: any,
    acceptFunction: Function,
    rejectFunction?: Function,
    messageKey?: string
  ) => {
      confirmDialog({
        message: messageKey ? t(messageKey) : t("generic.label.confirmDelete"),
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        accept: () => acceptFunction(data),
        reject: () => rejectFunction ? rejectFunction() : undefined,
      });
  };

  operationsAllowed = {
    showConfirmDeletePopup,
    showConfirmDeleteDialog
  };

  return (
    <UIServiceContext.Provider value={operationsAllowed}>
      <ToasterServiceProvider>{props.children}</ToasterServiceProvider>
    </UIServiceContext.Provider>
  );
};

export const useUIService = () => {
  return useContext(UIServiceContext);
};
